"use client";

import { memo } from "react";
import { cn } from "@/lib/utils";

type Props = {
	label: string;
};

function DateDivider({ label }: Props) {
	return (
		<li className="flex items-center justify-center py-6">
			<span className="inline-flex items-center justify-center rounded-full bg-card px-4 py-1.5 text-xs font-medium text-muted-foreground shadow-sm dark:date-divider-shadow">
				{label}
			</span>
		</li>
	);
}

export default memo(DateDivider);

